module.exports = __webpack_public_path__ + "static/img/img_shunfeng.eb0f3510.png";